import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore'
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/log';
import { SSelect } from "@avalara/skylab-sdk/react";

const log = new Logger('OPEN_RETURNS_STATUS_SELECTOR', LOG_LEVELS.DEBUG);

const STATUS_OVERDUE = "0";
const STATUS_ALMOST_OVERDUE = "6";
const STATUS_READY = "1";
const STATUS_NOT_READY = "3";

const AVAILABLE_STATUS = [
  STATUS_OVERDUE,
  STATUS_ALMOST_OVERDUE,
  STATUS_READY,
  STATUS_NOT_READY
];

export class OpenReturnsStatusSelector extends React.Component {

    selectionHandler(event) {
      log.debug('selectionHandler(): ', event);
      // log.debug('selectionHandler(): target.value: %s (%s)', event.target.value, typeof event.target.value);
      const status= {status: event.detail.item.value};
      // log.debug('selectionHandler(): status', status);
      this.props.selectionHandler(status);
    }

    getStatusOptions() {
      const statuses = this.props.statuses || [];
      let optionsList = [
        {
          label: _.isString(this.props.selectValueLanguageStringKey)
            ? LANGUAGES_CONTROLLER.format(this.props.languageString, this.props.selectValueLanguageStringKey)
            : LANGUAGES_CONTROLLER.format(this.props.languageString, "SelectOpenReturnsStatus"),
          value: "",
        },
      ];
      AVAILABLE_STATUS.forEach((value) => {
        if(statuses[value]) {
          optionsList.push({
            label: LANGUAGES_CONTROLLER.format(this.props.languages, statuses[value].languageString),
            value: value,
            selected: this.props.status === value? true: false,
          });
        }
      });
      return optionsList;
    }

    render() {
      log.debug('render(): ', this.props);

      return (
            <fieldset data-test="component-openreturn-status-selector" className={this.props.fieldsetClassName}>
              <label className="mr20"><LanguageStringResolver string='filterOpenReturnsStatus'/></label>
              <div data-test="component-openreturn-status-select" className="component-openreturn-status-select">
                <SSelect defaultValue={this.props.status} 
                  inputId="single-status-select"
                  name="status-select"
                  onS-select={this.selectionHandler.bind(this)}
                  optionsList={this.getStatusOptions() || []}
                  multiple={false}
                  showSelectionCount={false}
                />
              </div>
            </fieldset>
        )
    }
}


function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    statuses: state.content && state.content.data && state.content.data.openReturnStatuses,
    languages: state.languages
  };
}


OpenReturnsStatusSelector.defaultProps = {
  fieldsetClassName: ""
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(OpenReturnsStatusSelector);